module.exports = __webpack_public_path__ + "media/hand-clapping.d777bce6.mp3";